export default "__VITE_PUBLIC_ASSET__5d9632e7__"